<template>
    <div>

        <h3>Done?</h3>
        <p>Great work! You may want to consider:</p>
        <LinkBox>
            <li><router-link to="/frontend-serverless">Goto: Deploy Frontend to the Cloud</router-link></li>
        </LinkBox>
        <h3>Navigation</h3>
        <p>Want to go somewhere? Here are some <i>&lt;a&gt;</i>-tags for you:</p>
        <LinkBox>
            <li><router-link to="/frontend">Return: Frontend Mission</router-link></li>
            <li><router-link to="/api">Goto: API Specification</router-link></li>
        </LinkBox>
    </div>
</template>

<script>
import LinkBox from '@/components/LinkBox.vue'

export default {
    name: 'BackendNav',
    components: {
        LinkBox
    }
}
</script>


<style scoped>
.comment {
    color: #666666;
}
</style>